// Styles
// Using CSS Variables for Theme Support
export const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "var(--bg-primary)",
    color: "var(--text-primary)",
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    transition: "background-color 0.3s ease, color 0.3s ease",
  },
  navbar: {
    backgroundColor: "var(--bg-secondary)",
    color: "var(--text-primary)",
    padding: "0 2rem",
    height: "var(--header-height)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid var(--border-color)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 50,
  },
  navbarBrand: {
    fontSize: "1.25rem",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    color: "var(--text-primary)",
    letterSpacing: "-0.025em",
  },
  navbarNav: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
  },
  navLink: {
    color: "var(--text-secondary)",
    textDecoration: "none",
    padding: "0.5rem 0.75rem",
    borderRadius: "0.375rem",
    transition: "all 0.2s",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    border: "none",
    background: "none",
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  sidebar: {
    width: "var(--sidebar-width)",
    backgroundColor: "var(--bg-secondary)",
    height: "100vh",
    padding: "1.5rem",
    paddingTop: "calc(var(--header-height) + 1.5rem)",
    borderRight: "1px solid var(--border-color)",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 40,
    overflowY: "auto",
  },
  sidebarItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    padding: "0.75rem 1rem",
    borderRadius: "0.5rem",
    marginBottom: "0.25rem",
    cursor: "pointer",
    transition: "all 0.2s",
    textDecoration: "none",
    color: "var(--text-secondary)",
    fontSize: "0.925rem",
    fontWeight: "500",
  },
  sidebarItemActive: {
    backgroundColor: "var(--primary-light)",
    color: "var(--primary)",
  },
  mainContent: {
    marginLeft: "var(--sidebar-width)",
    marginTop: "var(--header-height)",
    padding: "2rem",
    minHeight: "calc(100vh - var(--header-height))",
  },
  card: {
    backgroundColor: "var(--bg-secondary)",
    borderRadius: "0.75rem",
    padding: "1.5rem",
    boxShadow: "var(--card-shadow)",
    marginBottom: "1.5rem",
    border: "1px solid var(--border-color)",
  },
  button: {
    backgroundColor: "var(--primary)",
    color: "white",
    padding: "0.625rem 1.25rem",
    borderRadius: "0.5rem",
    border: "none",
    cursor: "pointer",
    fontSize: "0.875rem",
    fontWeight: "600",
    transition: "all 0.2s",
    display: "inline-flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  buttonSecondary: {
    backgroundColor: "var(--bg-tertiary)",
    color: "var(--text-secondary)",
    border: "1px solid var(--border-color)",
  },
  input: {
    width: "100%",
    padding: "0.625rem",
    borderRadius: "0.5rem",
    border: "1px solid var(--border-color)",
    fontSize: "0.875rem",
    marginBottom: "1rem",
    backgroundColor: "var(--bg-primary)",
    color: "var(--text-primary)",
  },
  select: {
    width: "100%",
    padding: "0.625rem",
    borderRadius: "0.5rem",
    border: "1px solid var(--border-color)",
    fontSize: "0.875rem",
    marginBottom: "1rem",
    backgroundColor: "var(--bg-primary)",
    color: "var(--text-primary)",
  },
  textarea: {
    width: "100%",
    padding: "0.625rem",
    borderRadius: "0.5rem",
    border: "1px solid var(--border-color)",
    fontSize: "0.875rem",
    marginBottom: "1rem",
    minHeight: "100px",
    resize: "vertical",
    backgroundColor: "var(--bg-primary)",
    color: "var(--text-primary)",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1.5rem",
    marginBottom: "2rem",
  },
  gridCols2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1rem",
  },
  gridCols3: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "1rem",
  },
  statCard: {
    backgroundColor: "var(--bg-secondary)",
    borderRadius: "0.75rem",
    padding: "1.5rem",
    boxShadow: "var(--card-shadow)",
    textAlign: "center",
    border: "1px solid var(--border-color)",
  },
  statValue: {
    fontSize: "1.875rem",
    fontWeight: "700",
    marginBottom: "0.25rem",
    color: "var(--text-primary)",
  },
  statLabel: {
    color: "var(--text-muted)",
    fontSize: "0.875rem",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  tradeCard: {
    backgroundColor: "var(--bg-secondary)",
    borderRadius: "0.75rem",
    padding: "1.5rem",
    boxShadow: "var(--card-shadow)",
    marginBottom: "1rem",
    borderLeft: "4px solid var(--primary)",
    border: "1px solid var(--border-color)",
    borderLeftWidth: "4px",
  },
  tradeHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
  },
  tradeSymbol: {
    fontSize: "1.125rem",
    fontWeight: "700",
    color: "var(--text-primary)",
  },
  tradePnL: {
    fontSize: "1.125rem",
    fontWeight: "700",
  },
  profitText: {
    color: "var(--success)",
  },
  lossText: {
    color: "var(--danger)",
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    backdropFilter: "blur(2px)",
  },
  modalContent: {
    backgroundColor: "var(--bg-secondary)",
    borderRadius: "0.75rem",
    padding: "2rem",
    maxWidth: "500px",
    width: "90%",
    maxHeight: "80vh",
    overflowY: "auto",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    border: "1px solid var(--border-color)",
  },
  formGroup: {
    marginBottom: "1.25rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: "var(--text-secondary)",
  },
};
